/*
 * File: d:\projects\AutoFiFront\src\Content\Car\CarCardHeader\CarCardHeader.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday January 20th 2023
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import styles from "Content/Car/CarCardHeader/CarCardHeader.module.css";
import { BsFillCartCheckFill as Cart1} from 'react-icons/bs';
import { AiOutlineShoppingCart as Cart2} from 'react-icons/ai';
import translator from 'MultiLanguage/TranslationWrapper';
import React, { useEffect, useState } from 'react';
import Button from 'Theme/Component/Button';
import { IconSubSectionType } from './CarCardHeader.type';
import CartIcon from "Theme/Component/CartIcon";
import useFavIds from "Hooks/UseFavIds";

function  CarCardHeader (props: IconSubSectionType) {
    const [ _, setCookie ] = useFavIds();

    const [isLiked, setIsLiked] = useState(props.IsFav);
    const [iconToDisplay, setIconSubSection] = useState("");

    useEffect(() => {
        if (iconToDisplay == "")
        switch (props.IconSubSection) {
            case "BREAK":
                setIconSubSection("/IconsCarSubSection/BREAK_V1.svg");
                break;
            case "CITYCAR":
                setIconSubSection("/IconsCarSubSection/CITADINE_V1.svg");
                break;
            case "SUV":
                setIconSubSection("/IconsCarSubSection/SUV_V1.svg");
                break;
            case "UTILITY":
                    setIconSubSection("/IconsCarSubSection/VU_V1.svg");
                    break;
            case "SEDAN":
                setIconSubSection("/IconsCarSubSection/BERLINE_V1.svg");
                break;
            default:
                break;
        }
    }, [iconToDisplay]);

    const handleToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setIsLiked(!isLiked);
        const myCart:number = props.id;
        if (isLiked)
            setCookie(myCart, true);
        if (!isLiked)
            setCookie(myCart, false);
    };

    return (
        <React.Fragment>
            <div className={`${styles.label_car}`}>
                <div className={`${styles.left_part}`}>
                    {translator.decode("car.used_car")}
                    {iconToDisplay !== "" ? <img className={`${styles.icon_sub_car}`} src={iconToDisplay} alt="Car Icon"/> : null }
                </div>
                <Button onClick={handleToggle} aria-label="Add item to cart" >
                    {
                        isLiked ?
                        <CartIcon bgColor={props.themeColor}><Cart1/></CartIcon>
                        :
                        <CartIcon bgColor={props.themeColor}><Cart2/></CartIcon>
                    }
                </Button>
            </div>
        </React.Fragment>
    );
}

export default CarCardHeader;
